module.exports = __webpack_public_path__ + "fonts/baronsans-hairline-webfont.6e5a86ae.woff2";